var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3333 5.99996C7.3333 5.26361 7.93028 4.66663 8.66663 4.66663H26C26.7363 4.66663 27.3333 5.26361 27.3333 5.99996C27.3333 6.73632 26.7363 7.33329 26 7.33329H8.66663C7.93028 7.33329 7.3333 6.73626 7.3333 5.99996ZM26 12.6666H1.99996C1.26361 12.6666 0.666626 13.2637 0.666626 14C0.666626 14.7363 1.26361 15.3333 1.99996 15.3333H26C26.7363 15.3333 27.3333 14.7363 27.3333 14C27.3333 13.2637 26.7363 12.6666 26 12.6666ZM26 20.6666H14C13.2637 20.6666 12.6666 21.2636 12.6666 22C12.6666 22.7363 13.2637 23.3333 14 23.3333H26C26.7363 23.3333 27.3333 22.7363 27.3333 22C27.3333 21.2636 26.7363 20.6666 26 20.6666Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.69cf721efd523d4da7283e6c6377631c.svg";
export { ForwardRef as ReactComponent };